import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { VOUCHER_TYPE_PATH } from '../../../../config/paths';
import {
  clearVoucherType,
  getVoucherType,
  putVoucherType,
} from '../../../../actions';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import VoucherTypeForm from './VoucherTypeForm';

const EditVoucherType = ({
  breadcrumbs,
  dispatchGetVoucherType,
  dispatchClearVoucherType,
  dispatchPutVoucherType,
  match: {
    params: { id: voucherTypeId },
  },
  loading,
  voucherType,
}) => {
  useLayoutEffect(() => {
    dispatchGetVoucherType({ voucherTypeId });

    return () => dispatchClearVoucherType();
  }, []);

  const onSubmit = (formValues) =>
    dispatchPutVoucherType(voucherTypeId, {
      ...formValues,
    });

  const generateInitialValues = ({
    name,
    description,
    voucherCode,
    displayInPaymentsPage
  }) => ({
    name,
    description,
    voucherCode,
    displayInPaymentsPage
  });

  let content;

  if (loading) content = <Loader />;
  else if (voucherType.isEmpty())
    content = <NoDataResource returnPage={VOUCHER_TYPE_PATH} />;
  else
    content = (
      <VoucherTypeForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(voucherType.toJS())}
      />
    );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Tipo de Comprobante"
      subtitle="Editar tipo de comprobante"
      content={content}
    />
  );
};

EditVoucherType.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearVoucherType: PropTypes.func.isRequired,
  dispatchGetVoucherType: PropTypes.func.isRequired,
  dispatchPutVoucherType: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  voucherType: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditVoucherType.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearVoucherType: clearVoucherType,
  dispatchGetVoucherType: getVoucherType,
  dispatchPutVoucherType: putVoucherType,
};

const mapStateToProps = (
  { AccountingUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tipos de Comprobantes',
      href: VOUCHER_TYPE_PATH,
    },
    {
      text: 'Ver',
      href: `${VOUCHER_TYPE_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  voucherType: AccountingUnit.VoucherType.getIn(['current', 'content']),
  loading: !AccountingUnit.VoucherType.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditVoucherType);
